import { ObjectSchema, object, number } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { InputAddressFormValue } from '../../models/duty-engineer';
yup.setLocale(locale);

export function inputAddressValidator(): ObjectSchema<InputAddressFormValue> {
    return object(addressValidationFields).strict().noUnknown();
}

export const addressValidationFields = {
    fcuNum: number().integer().nullable().strict(),
    fuNum: number().integer().nullable().strict(),
    slotNum: number()
        .integer()
        .nullable()
        .strict()
        .when('fcuNum', {
            is: (val: any) => val !== null && val !== undefined,
            then: schema => schema.required(),
            otherwise: schema => schema.nullable().optional(),
        }),
    terminal: number()
        .integer()
        .nullable()
        .strict()
        .when('slotNum', {
            is: (val: any) => val !== null && val !== undefined,
            then: schema => schema.required(),
            otherwise: schema => schema.nullable().optional(),
        }),
};
